// src/enums/role-id.enum.js

export const RoleId = Object.freeze({
  Administrator: 4,
  SuperAdmin: 22,
  InsuranceDepartment: 9,
});
